import React, { useState } from "react";
import { FiCheckSquare, FiSquare } from "react-icons/fi";

export default function TopRiskDistrictsUI({
    title = "Top high-risk districts",
    data = [],
}) {
    const [showTribalOnly, setShowTribalOnly] = useState(false);

    const filteredData = showTribalOnly
        ? data.filter((d) => d.category === "Tribal")
        : data;

    return (
        <div className="bg-white p-4 rounded-2xl shadow-sm" style={{ height: "40vh" }}>
            {/* HEADER */}
            <div className="flex items-start justify-between mb-3">
                <div>
                    <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
                    <p className="text-[11px] text-slate-500 mt-0.5">
                        Ranked by combined risk (MMR, NMR, ANC, Inst. Delivery, LBW, Reporting)
                    </p>
                </div>

                {/* Tribal Filter */}
                <label className="flex items-center gap-1.5 text-xs cursor-pointer select-none text-slate-700">
                    <input
                        type="checkbox"
                        checked={showTribalOnly}
                        onChange={(e) => setShowTribalOnly(e.target.checked)}
                        className="w-3.5 h-3.5 accent-blue-600"
                    />
                    Tribal focus
                </label>
            </div>

            {/* DISTRICT LIST */}
            <div className="space-y-2.5">
                {filteredData.map((item, idx) => (
                    <div
                        key={idx}
                        className={`px-4 py-2 rounded-xl border flex items-center justify-between transition-all 
            ${idx === 0
                                ? ""
                                : "border-slate-200 hover:bg-slate-50"
                            }`} // bg-blue-50
                    >
                        {/* LEFT SIDE */}
                        <div className="flex flex-col">
                            {/* Rank + District + Category */}
                            <div className="flex items-center gap-2">
                                <span className="text-sm font-semibold text-slate-700">
                                    #{item.rank}
                                </span>

                                <span className="text-sm text-slate-800 font-medium">
                                    {item.district}
                                </span>

                                {item.category === "Tribal" && (
                                    <span className="text-[10px] px-2 py-[2px] rounded-full font-medium
                  bg-yellow-50 text-yellow-700 border border-yellow-200 shadow-sm">
                                        Tribal
                                    </span>

                                )}
                            </div>

                            {/* Metrics Line */}
                            <p className="text-[11px] text-slate-500 mt-0.5">
                                MMR {item.mmr} • NMR {item.nmr} • ANC4 {item.anc4}% • Inst. {item.inst}%
                            </p>
                        </div>

                        {/* RIGHT – Risk Score */}
                        <div className="text-right">
                            <span className="text-[11px] text-slate-500 block">Risk</span>
                            <span className="text-lg font-semibold text-red-600">
                                {item.score}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
